'use client'

import { useEffect } from 'react'

// Route-level error boundary. Without this, any uncaught render/effect throw bubbles to the root
// and Next.js shows a blank white screen in production. This renders a recoverable state instead,
// so the user can retry or reload rather than staring at nothing.
//
// The copy is deliberately CAUSE-AGNOSTIC. It used to assert "this can happen on Safari if
// browser storage is blocked", which was the crash that prompted this boundary — but the boundary
// catches every uncaught throw, so that text was shown to users whose error had nothing to do
// with storage, and sent support down the wrong path. State the symptom, offer the recovery, and
// keep the storage note as a soft secondary hint only.
export default function Error({ error, reset }) {
  useEffect(() => {
    console.error('App error boundary caught:', error)
  }, [error])

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'var(--background-bg-color, #0f0f14)',
    color: 'var(--main-text-color, #ffffff)',
    padding: '24px',
    textAlign: 'center',
    gap: '18px',
  }

  const buttonStyle = {
    background: '#7a74eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '9999px',
    padding: '10px 24px',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
  }

  const linkStyle = {
    background: 'transparent',
    color: '#7a74eb',
    border: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    textDecoration: 'underline',
  }

  return (
    <div style={containerStyle}>
      <h2 style={{ fontSize: '20px', fontWeight: 700 }}>
        Something went wrong
      </h2>
      <p style={{ maxWidth: '420px', opacity: 0.8, fontSize: '15px' }}>
        We hit an unexpected error. Try again, or reload the page.
      </p>
      <p style={{ maxWidth: '420px', opacity: 0.55, fontSize: '13px' }}>
        If it keeps happening, a browser extension or blocked site storage may
        be interfering — try a normal window with your usual privacy settings.
      </p>
      <button style={buttonStyle} onClick={() => reset()}>
        Try again
      </button>
      <button
        style={linkStyle}
        onClick={() => {
          if (typeof window !== 'undefined') window.location.reload()
        }}
      >
        Reload the page
      </button>
    </div>
  )
}
